var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Route } from "react-router";
import { Link } from "react-router-dom";
import { Button, Dimmer, Form, Loader, Message, } from 'semantic-ui-react';
import { AppPaths, UiConfigContext } from "../../AppConfig";
import proteinLogo from "../../images/logo_Protein.png";
import { CatalogMode } from "../../RequestHelpers";
import CornerLogoContainer from "../CornerLogoContainer";
import { buildEditFormStateHandlerForComponent } from "../FormState";
import { SecondaryIfCatalogLoader } from "../secondary-if/SecondaryIfCatalog";
import { CART_PRICE_PATH } from "../rna-fish/EditKitForm";
import { LoadWrapper } from "../rna-fish/LoadWrapper";
import { addToCartHandlerBuilder } from "../rna-fish/NewRnaFishKitPage";
import { defaultManualGoldIfFormState, EditKitForm, serializeManualGoldIfKit, } from "./EditKitForm";
var NewManualGoldIfKitPage = /** @class */ (function (_super) {
    __extends(NewManualGoldIfKitPage, _super);
    function NewManualGoldIfKitPage(props) {
        return _super.call(this, props) || this;
    }
    NewManualGoldIfKitPage.prototype.render = function () {
        var _this = this;
        var renderer = function (catalog) {
            return React.createElement(NewKitContent, { catalog: catalog, adminUser: _this.props.adminUser });
        };
        return React.createElement(LoadWrapper, { loader: new SecondaryIfCatalogLoader(CatalogMode.Consumer), render: renderer });
    };
    return NewManualGoldIfKitPage;
}(React.PureComponent));
export default NewManualGoldIfKitPage;
var NewKitContent = /** @class */ (function (_super) {
    __extends(NewKitContent, _super);
    function NewKitContent(props) {
        var _this = _super.call(this, props) || this;
        _this.onAddToCart = addToCartHandlerBuilder(function (callback) {
            _this.setState({
                loading: true,
                addToCartButtonPressed: true
            }, callback);
        }, function () { return JSON.stringify(serializeManualGoldIfKit(_this.state.formState)); }, function (history) {
            _this.setFormState(function () { return ({
                errors: [],
            }); }, function () {
                _this.setState({
                    loading: false,
                }, function () {
                    history.push('/cart');
                });
            });
        }, function (errors) {
            _this.setFormState(function () { return ({
                errors: errors.errors,
            }); }, function () {
                _this.setState({
                    loading: false,
                });
            });
        });
        _this.setFormState = buildEditFormStateHandlerForComponent('formState', _this);
        // Helper to allow us to access Route info in a click handler
        _this.addToCartButton = function (props) {
            var onClick = function () {
                // tslint tells me that inline lambdas in props are slow, so we do it here...?
                _this.onAddToCart(props.history);
            };
            return React.createElement(Button, { icon: 'cart plus', label: 'Add to cart', labelPosition: 'left', onClick: onClick, positive: true });
        };
        _this.state = {
            loading: false,
            formState: defaultManualGoldIfFormState(props.catalog),
            addToCartButtonPressed: false
        };
        return _this;
    }
    NewKitContent.prototype.render = function () {
        return React.createElement(CornerLogoContainer, { img: proteinLogo, alt: 'Protein logo' },
            React.createElement("div", { id: "non-header-portion" },
                React.createElement("h1", { className: 'branded' }, "HCR\u2122 Gold IF Kit"),
                React.createElement("h2", { className: 'branded' }, "Game-changing multiplex, quantitative, high-resolution protein imaging"),
                React.createElement("span", { style: { float: 'right', marginTop: '2rem' } }, React.createElement("a", { href: "https://www.molecularinstruments.com/hcr-gold-protocols" }, "HCR\u2122 Gold User Guides")),
                React.createElement("p", { className: 'branded', style: { width: '50%' } },
                    React.createElement(React.Fragment, null,
                        "Order one HCR\u2122 Gold IF kit per target protein (select a different HCR\u2122 HiFi Encoder and HCR\u2122 Gold Amplifier for each target protein). Use your own trusted 1\u00BA antibodies (",
                        React.createElement("em", null, "same"),
                        " host species/isotype for each target protein if desired).")),
                React.createElement("br", null),
                React.createElement(UiConfigContext.Consumer, null, function (uiConfig) {
                    if (!uiConfig.authenticated) {
                        return React.createElement(Message, { color: "yellow", className: 'legacy-notification' },
                            React.createElement("h2", { className: 'branded' }, "Special Pricing for Academic Users!"),
                            React.createElement(Link, { to: AppPaths.REGISTER }, "Register"),
                            " to see applicable discounts. Special academic pricing is applied to your account automatically once you\u2019re signed in.",
                            React.createElement("br", null),
                            " ",
                            React.createElement("span", { style: { float: "right", marginRight: "4rem" } }, "\u2014 The MI Team"),
                            " ",
                            React.createElement("br", null));
                    }
                    else {
                        return React.createElement(React.Fragment, null);
                    }
                }),
                React.createElement(Dimmer.Dimmable, { as: Form, error: this.state.formState.errors.length > 0 },
                    React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                        React.createElement(Loader, null)),
                    React.createElement(EditKitForm, { kitPriceUrlPath: CART_PRICE_PATH, catalog: this.props.catalog, formState: this.state.formState, loadPriceOnMount: true, enableCustomPrice: false, enableAdminSystems: false, setFormState: this.setFormState, showErrors: this.state.addToCartButtonPressed }),
                    React.createElement("div", null,
                        React.createElement("p", { className: 'branded', style: { width: '50%' } },
                            "Combine with ",
                            React.createElement(Link, { to: AppPaths.LOCAL_NEW_KIT_RNA_FISH }, "HCR\u2122 Gold RNA-FISH kits"),
                            " for unified multiplex, quantitative, high-resolution RNA and protein imaging."),
                        React.createElement("div", { style: { float: 'right' } },
                            React.createElement("div", { style: { 'textAlign': 'right' } },
                                React.createElement(Route, { render: this.addToCartButton }))),
                        React.createElement("div", { style: { clear: 'both' } })))));
    };
    return NewKitContent;
}(React.PureComponent));
//# sourceMappingURL=NewManualGoldIfKitPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/manual-gold-if/NewManualGoldIfKitPage.js
// module id = 1376
// module chunks = 0